/* ==========================================================================
   SelectPanel > Constants
   ========================================================================== */

module.exports = {
    APPENDTOPARENT: true,
    AUTOWIDTH: false,
    ESCAPE_CODE: 27,
    PLACEMENT: 'bottom',
    ICON: 'angle-down'
};
